import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { InitiateAccountRecovery, OauthAEMConfig } from '../../../models';
import { UtilService } from '../../util-service/util-service';
@Injectable({
  providedIn: 'root'
})
export class InitiateSelfServicePasswordResetService {
  initiateAccountRecoveryHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.initiateAccountRecovery+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  initiateAccountRecovery = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<InitiateAccountRecovery> => {
    const url = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const initiateAccountRecoveryUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: url
      }
    ];

    return new ApiBuilder<undefined, InitiateAccountRecovery>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(initiateAccountRecoveryUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.initiateAccountRecoveryHeader)
      .errorHandler(this._errorHandler)
      .library('INITIATE_ACCOUNT_RECOVERY_SERVICE')
      .withCredentials(true)
      .create();
  };
}
